export default __webpack_public_path__ + "static/media/portfolio-03.931156bb.jpg";